import { useState, useEffect } from 'react';
import Modal from "../../modal/Modal";
import {useModal} from "../../modal/useModal";
import useYupValidationResolver from "../../../util/useYupValidationResolver";
import {FormProvider, useForm} from "react-hook-form";
import {showErrorNotification, showSuccessNotification} from "../../../util/notifications";
import Field from "../../form/Field";
import apiKeySchema from "./validation/apiKeySchema";
import useApi from "../../../api";
import classNames from 'classnames';
import {useQueryClient} from "react-query";

const GenerateApiKeyModal = ({modalId}) => {
    const {closeModal} = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const [apiKey, setApiKey] = useState(null);
    const [showApiKey, setShowApiKey] = useState(false);
    const {createApiKey} = useApi();
    const queryClient = useQueryClient();
    const resolver = useYupValidationResolver(apiKeySchema);
    const formMethods = useForm({
        resolver,
    });

    useEffect(() => {
        if (showApiKey) {
            const el = document.querySelector('.form_field--text');
            el.select();
        }
    }, [showApiKey]);

    const {handleSubmit} = formMethods;

    const onSubmit = async (data) => {
        setIsLoading(true);
        console.log(data);
        try {
            const response = await createApiKey(data);
            await queryClient.invalidateQueries('apikeys');
            console.log(response);
            setApiKey(response.data)
            showSuccessNotification('API key generated!');
        } catch (e) {
            console.error(e);
            showErrorNotification('Something went wrong generating the API key.');
        }
        setIsLoading(false);
    }

    const onError = (error) => {
        console.log(error);
    }

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Generate API Key</h1>
            {apiKey ? (
                <>
                    <div className="notification notification--inline">
                        Important! Make sure to save this API key. It will not be shown again. You can always generate a new key.
                    </div>
                    <br/>
                    <div className="table__row">
                        <div className="table__label">
                            {apiKey.name}
                        </div>
                        <div className="table__value">
                            {showApiKey ? (
                                <>
                                    <input className="form_field--text" value={apiKey.apiKey} readOnly />
                                </>
                            ) : '******'}
                            <br/>
                            <span className="link" onClick={() => setShowApiKey(!showApiKey)}>{showApiKey ? 'Hide' : 'Show'} key</span>
                        </div>
                    </div>
                </>
            ) : (
                <FormProvider {...formMethods} >
                    <form onSubmit={handleSubmit(onSubmit, onError)} noValidate className="form">
                        <Field
                            label="Name"
                            type="text"
                            name="name"
                            maxLength={50}
                            defaultValue="New API Key"
                        />
                        <button className={buttonClass}>Generate API key</button>
                    </form>
                </FormProvider>
            )}
            <div className="modal__footer">
                <button className="button button--link" onClick={() => closeModal(modalId)}>Close</button>
            </div>
        </Modal>
    )
};

export default GenerateApiKeyModal;
